/* eslint-disable @angular-eslint/prefer-on-push-component-change-detection */
import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, Input, input, OnInit, signal } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { PalantirCardComponent, PalantirIconComponent, PalantirLabelColorsEnum, PalantirTagComponent, PalantirTextComponent, PalantirTooltipModule } from '@fieldcontrol/palantir'
import { TranslateModule } from '@ngx-translate/core'
import { MaintenanceTabWarrantiesService } from '../../services/warranties.service'
import { WarrantyForm } from '../../warranties.type'

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  selector: 'maintenance-warranty-card',
  styleUrls: ['./warranty-card.component.scss'],
  templateUrl: './warranty-card.component.html',
  standalone: true,
  imports: [CommonModule, PalantirCardComponent, PalantirTextComponent, PalantirTagComponent, PalantirIconComponent, PalantirTooltipModule, TranslateModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MaintenanceWarrantyCardComponent implements OnInit {
  @Input({ required: true }) public warrantyForm!: FormGroup<WarrantyForm>
  @Input({ required: true }) public isSelected!: boolean
  @Input() public isSingleWarranty: boolean = false
  public isLoading = input<boolean>(false)
  public tag = signal<({ color: PalantirLabelColorsEnum, label: string })>(this.maintenanceTabWarrantiesService.mapperTag(this.warrantyForm))

  public constructor (
    private readonly maintenanceTabWarrantiesService: MaintenanceTabWarrantiesService
  ) {}

  public ngOnInit(): void {
    this.tag.set(this.maintenanceTabWarrantiesService.mapperTag(this.warrantyForm))
  }
}
